import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart--sprite",
  "use": "heart--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"heart--sprite\">\n<path d=\"M7.99992 14.1171L7.03325 13.2371C3.59992 10.1238 1.33325 8.07046 1.33325 5.55046C1.33325 3.49712 2.94659 1.88379 4.99992 1.88379C6.15992 1.88379 7.27325 2.42379 7.99992 3.27712C8.72658 2.42379 9.83992 1.88379 10.9999 1.88379C13.0533 1.88379 14.6666 3.49712 14.6666 5.55046C14.6666 8.07046 12.3999 10.1238 8.96658 13.2438L7.99992 14.1171Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol